import { first, OperatorFunction } from "rxjs";

export function firstDefined<T>():OperatorFunction<T,T>{
	return first(v=>v!==undefined);
}
